import React from 'react'
import { Input } from '@/components/ui/input'
import { cn } from '@/utils/index'

type MeasureInputProps = {
  id: string
  prefix: string
  suffix?: string | null
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  error: boolean
}

/** Text input with a leading axis letter and an optional trailing unit; Enter blurs (commits). */
export const MeasureInput: React.FC<MeasureInputProps> = ({
  id,
  prefix,
  suffix,
  value,
  onChange,
  onBlur,
  error,
}) => {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-sm text-[var(--base-muted-foreground,#737373)]">
        {prefix}
      </span>
      <Input
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            ;(event.target as HTMLInputElement).blur()
          }
        }}
        error={error}
        className={cn(
          'h-9 rounded-md border-[var(--base-border,#E5E5E5)] bg-[var(--base-background,#FFF)] pl-9 text-sm text-[var(--base-foreground,#0A0A0A)] shadow-xs',
          suffix ? 'pr-10' : 'pr-3',
          'placeholder:text-[var(--base-muted-foreground,#737373)]',
          'focus-visible:border-[var(--base-border,#E5E5E5)] focus-visible:ring-[var(--ring,#144087)]/15'
        )}
      />
      {suffix ? (
        <span className="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-sm text-[var(--base-muted-foreground,#737373)]">
          {suffix}
        </span>
      ) : null}
    </div>
  )
}
